import {
    Box,
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    List,
    ListItem,
    Typography,
    useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Config from "Config";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import AlertDialog from "../../component/AlertDialog/AlertDialog";
import ErrorMsg from "../../component/ErrorMsg/ErrorMsg";
import Header from "../../component/Header/Header";
import PortalNavbar from "../../component/PortalNavbar/PortalNavbar";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import { setSsloResetPasswordTime } from "../../redux/action";
import { send } from "../../SendRequest";

const useStyles = makeStyles({
    root: {
        width: "85%",
        height: "100%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
});

function ForgotPassword() {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery("(min-width:600px)");
    const dispatch = useDispatch();
    const ssloResetPassWordTime = useSelector(
        (state) => state.ssloResetPassWordTime
    );
    const [userEmail, setUserEmail] = useState("");
    const [post, setPost] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [noUser, setNoUser] = useState(false);
    const [withinOneMin, setWithinOneMin] = useState(false);
    const [accountLocked, setAccountLocked] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [countdown, setCountdown] = useState(0);
    const [emailError, setEmailError] = useState(false);

    const calculateWithin60Seconds = () => {
        if (!ssloResetPassWordTime) return false;
        const currentTime = new Date().getTime();
        const timeDiff = Math.floor(
            (currentTime - ssloResetPassWordTime) / 1000
        );
        return timeDiff <= 60;
    };

    const validateEmail = (email) => {
        const emailRegex = /^.+@.+$/;
        return emailRegex.test(email);
    };

    useEffect(() => {
        if (ssloResetPassWordTime && calculateWithin60Seconds()) {
            setButtonDisabled(true);
            const timePassed = Math.floor(
                (new Date().getTime() - ssloResetPassWordTime) / 1000
            );
            setCountdown(60 - timePassed);

            const interval = setInterval(() => {
                const timeDiff = Math.floor(
                    (new Date().getTime() - ssloResetPassWordTime) / 1000
                );
                const remainingTime = 60 - timeDiff;

                if (remainingTime > 0) {
                    setCountdown(remainingTime);
                } else {
                    setCountdown(0);
                    setButtonDisabled(false);
                    clearInterval(interval);
                }
            }, 1000);

            return () => {
                clearInterval(interval);
            };
        }
    }, [ssloResetPassWordTime]);

    const handleConfirm = () => {
        setNoUser(false);
    };
    const handleSavedClose = () => {
        setIsOpen(false);
    };
    const onSubmit = () => {
        console.log("submitted:" + userEmail);

        // 校验邮箱格式
        if (!userEmail.trim()) {
            setEmailError(true);
            return;
        }

        if (!validateEmail(userEmail)) {
            setEmailError(true);
            return;
        }

        setEmailError(false);
        setWithinOneMin(false);
        setAccountLocked(false);
        const option = {
            url: `${Config.CONTENT_PATH}/users/forgotpw/${userEmail}`,
            method: "PUT",
        };
        dispatch(send("FORGOT_PASSWORD", option))
            .then((response) => response.json())
            .then((result) => {
                // if (isObjectEmpty(result)) {
                //     setNoUser(true);
                // } else
                if (result?.errorMsg == "within1min") {
                    setWithinOneMin(true);
                } else if (result?.errorMsg == "ACCOUNT_LOCKED") {
                    setAccountLocked(true);
                } else {
                    const currentTime = new Date().getTime();
                    dispatch(setSsloResetPasswordTime(currentTime));
                    setButtonDisabled(true);
                    setIsOpen(true);
                }
            })
            .catch((error) => {
                console.log("fetch error: ", error);
            });
    };

    // console.log("email:" + userEmail);

    return (
        <Container maxWidth="md">
            <Header
                headerTitle={t("common.portal.forgotPassword")}
                className="header"
            ></Header>
            <Box className="container">
                <PortalNavbar aside className="drawer" />
                <main Box className="main">
                    <Typography style={{ marginLeft: "1rem" }}>
                        {t("common.portal.resetPassword")}
                    </Typography>
                    <List
                        sx={{
                            width: "100%",
                            maxWidth: 360,
                            bgcolor: "background.paper",
                            p: 2,
                        }}
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                    >
                        <ListItem>
                            <Typography>{t("common.email")}: &nbsp;</Typography>
                            <CustomTextField
                                style={{ width: "40%" }}
                                defaultValue={userEmail}
                                onChange={(e) => {
                                    setUserEmail(e.target.value);
                                    if (emailError) {
                                        setEmailError(false);
                                    }
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        onSubmit();
                                    }
                                }}
                                error={emailError}
                            ></CustomTextField>
                        </ListItem>
                    </List>
                    {emailError && (
                        <ErrorMsg
                            message={t("errorMsg.email.rule")}
                            style={{
                                paddingLeft: "3.8rem",
                                paddingDown: "2rem",
                                marginTop: "0px",
                            }}
                        />
                    )}
                    {withinOneMin && (
                        <ErrorMsg
                            message={t("common.portal.forgotPwCooldown")}
                            style={{
                                paddingLeft: "3.8rem",
                                paddingDown: "2rem",
                                marginTop: "0px",
                            }}
                        />
                    )}
                    {accountLocked && (
                        <ErrorMsg
                            message={t("common.login.error.accountLocked")}
                            style={{
                                paddingLeft: "3.8rem",
                                paddingDown: "2rem",
                                marginTop: "0px",
                            }}
                        />
                    )}
                    <Divider
                        variant="middle"
                        style={{ width: "50%", marginLeft: "1rem" }}
                    />
                    <br />
                    <Button
                        style={{ marginLeft: "1rem" }}
                        className="buttons"
                        variant="contained"
                        color="primary"
                        onClick={onSubmit}
                        disabled={buttonDisabled}
                    >
                        {`${t("common.portal.getResetEmail")}${
                            buttonDisabled && countdown > 0
                                ? ` ${countdown}${
                                      i18n.language.includes("tc") ||
                                      i18n.language.includes("sc")
                                          ? "秒"
                                          : "s"
                                  }`
                                : ""
                        }`}
                    </Button>

                    <br />
                    {/* </Box> */}
                </main>
            </Box>
            <Dialog aria-labelledby="simple-dialog-title" open={isOpen}>
                <DialogTitle
                    id="simple-dialog-title"
                    style={{ textAlign: "center" }}
                >
                    {/*{t("common.portal.resetEmailSentTitle")}*/}
                </DialogTitle>
                <DialogContent>
                    {t("common.portal.resetEmailSent")}
                </DialogContent>
                <DialogActions>
                    <Button
                        autoFocus
                        onClick={handleSavedClose}
                        color="success"
                    >
                        <b>{t("common.portal.confirm")}</b>
                    </Button>
                </DialogActions>
            </Dialog>
            <AlertDialog
                formOpen={noUser}
                content={t("common.portal.noSsloUser")}
                confirmButton={{
                    action: handleConfirm,
                    label: t("common.reload.popup.confirm"),
                }}
            />
        </Container>
    );
}
export default ForgotPassword;
